module.exports = __webpack_public_path__ + "img/img_zhuoganglian2.9923d9e2.png";